import { FcImageMaxContentLength } from './fc_images'
import axios, { ResponseType } from 'axios'

export interface FcFetchData {
  data?: any
  status: number
  contentType?: string
  error?: string
}

export interface FcFetchFunction {
  (url: string, responseType: ResponseType, maxLength?: number): Promise<FcFetchData>
}

let fetchFunc: FcFetchFunction = fcFetchUrlWithHttp

export function fcSetFetchFunction(func: FcFetchFunction): void {
  fetchFunc = func
}

export async function fcFetchUrl(
  url: string,
  responseType: ResponseType,
  maxLength?: number
): Promise<FcFetchData> {
  return fetchFunc(url, responseType, maxLength)
}

export async function fcFetchUrlWithHttp(
  url: string,
  responseType: ResponseType,
  maxLength?: number
): Promise<FcFetchData> {
  if (!maxLength) {
    maxLength = FcImageMaxContentLength
  }
  try {
    const response = await axios.get(url, { responseType, maxContentLength: maxLength })
    if (response.status !== 200) {
      return { status: response.status }
    }
    const contentType = response.headers['content-type']
    return { data: response.data, contentType, status: 200 }
  } catch (err) {
    return { status: 500, error: err.toString() }
  }
}
